import { render, staticRenderFns } from "./Cardv2.vue?vue&type=template&id=bde55260&"
import script from "./Cardv2.vue?vue&type=script&lang=js&"
export * from "./Cardv2.vue?vue&type=script&lang=js&"
import style0 from "./Cardv2.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports